import * as Yup from 'yup';
import { REMOVE_COMMAS_REGEX } from '../../commons/constants';

const paymentValidationSchema = (renderContent, balanceDue) =>
  Yup.object().shape({
    firstNameOnCard: Yup.string().required(
      renderContent('formBookingAmendRequiredFirstName', 'First name is required'),
    ),
    lastNameOnCard: Yup.string(
      renderContent('formBookingAmendFieldLastName', 'Enter your last namne'),
    ).required(renderContent('formBookingAmendRequiredLastName', 'Last name is required')),
    cardNumber: Yup.string(
      renderContent('paymentBookingAmendCardNumberRequired', 'Enter a valid credit card number'),
    ).required(
      renderContent('paymentBookingAmendCardNumberRequired', 'Enter a valid credit card number'),
    ),
    paymentValue: Yup.string(),
    amount: Yup.string().when('paymentValue', {
      is: 'customAmount',
      then: Yup.string()
        .required(renderContent('paymentBookingAmendAmountRequired', 'Amount required'))
        .test({
          name: 'higerAmount',
          exclusive: false,
          params: { balanceDue },
          message: renderContent(
            'paymentBookingAmendHigherBalanceDue',
            'Value can not be higher than the balance due',
          ),
          test: async (value) => {
            const stringAmount = value ? value.replace(REMOVE_COMMAS_REGEX, '') : '';
            return balanceDue >= Number(stringAmount);
          },
        })
        .test({
          name: 'negativeAmount',
          exclusive: false,
          params: { balanceDue },
          message: renderContent(
            'paymentBookingAmendAmountCanNotBeLessThanOne',
            'Amount must be 1 or greater',
          ),
          test: (value) => {
            const stringAmount = value ? value.replace(REMOVE_COMMAS_REGEX, '') : '';
            const amount = Number(stringAmount);
            const payment = balanceDue - amount;

            return payment >= 0;
          },
        })
        .test({
          name: 'minimunAmount',
          exclusive: false,
          message: renderContent(
            'paymentBookingAmendAmountCanNotBeLessThanOne',
            'Amount must be 1 or greater',
          ),
          test: (value) => {
            const stringAmount = value ? value.replace(REMOVE_COMMAS_REGEX, '') : '';
            const amount = Number(stringAmount);
            return amount >= 1;
          },
        }),
    }),
  });

export default paymentValidationSchema;
